import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDuration(seconds) {
  if (!seconds) return "0:00";
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }
  return `${minutes}:${secs.toString().padStart(2, "0")}`;
}

export function formatTimestamp(seconds) {
  if (!seconds && seconds !== 0) return "00:00";
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }
  return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}

export function formatDate(dateString, language = "en") {
  const date = new Date(dateString);
  return date.toLocaleDateString(language === "es" ? "es-ES" : "en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getStatusLabel(status, language = "en") {
  const labels = {
    en: {
      pending: "Preparing",
      processing: "Processing",
      extracting_audio: "Processing",
      transcribing: "Processing",
      analyzing: "Processing",
      completed: "Completed",
      failed: "Failed",
    },
    es: {
      pending: "Preparando",
      processing: "Procesando",
      extracting_audio: "Procesando",
      transcribing: "Procesando",
      analyzing: "Procesando",
      completed: "Completado",
      failed: "Fallido",
    }
  };
  return labels[language]?.[status] || labels.en[status] || status;
}

export function getProcessingMessage(status, language = "en") {
  const messages = {
    en: {
      pending: "We’ll start working on your file shortly.",
      processing: "We’re working on your file now. You can safely come back later.",
      extracting_audio: "We’re working on your file now. You can safely come back later.",
      transcribing: "We’re working on your file now. You can safely come back later.",
      analyzing: "We’re working on your file now. You can safely come back later.",
    },
    es: {
      pending: "Comenzaremos a trabajar en tu archivo pronto.",
      processing: "Estamos trabajando en tu archivo. Puedes volver más tarde sin problema.",
      extracting_audio: "Estamos trabajando en tu archivo. Puedes volver más tarde sin problema.",
      transcribing: "Estamos trabajando en tu archivo. Puedes volver más tarde sin problema.",
      analyzing: "Estamos trabajando en tu archivo. Puedes volver más tarde sin problema.",
    }
  };
  return messages[language]?.[status] || messages.en[status] || "";
}

export function sanitizeSpeakerDisplayName(value, fallback = "") {
  const baseValue = typeof value === "string" ? value : fallback;
  const trimmed = baseValue.trim();
  if (!trimmed) return fallback;
  return trimmed.replace(/[\s\-–—:;,\.]+$/g, "").trim() || fallback;
}
